import { gql } from '@apollo/client';

export const restore = gql`
  mutation restore($input: RestoreInput!) {
    restore(input: $input) {
      state
      errors
    }
  }
`;
